import * as React from 'react';

export const TopArrow: React.FC<{ fill?: string }> = ({ fill = 'white' }) => (
  <svg width="16" height="6" viewBox="0 0 16 6" fill="none">
    <path d="M8 6L0 0H16L8 6Z" fill={fill} />
  </svg>
);
